import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  StatusID: 2,
};

export const overviewSlice = createSlice({
  name: 'overview',
  initialState,
  reducers: {
    overview: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearOverviewData: (state, action) => {
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { overview, clearOverviewData } = overviewSlice.actions;

export default overviewSlice.reducer;
